import {
  SafeHtml,
  SafeStyle,
  SafeScript,
  SafeUrl,
  SafeResourceUrl,
} from '@angular/platform-browser';

export type SafeValue = SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl | string;

export enum DomSanitizerContext {
  HTML = 'html',
  STYLE = 'style',
  SCRIPT = 'script',
  URL = 'url',
  RESOURCE_URL = 'resource_url',
}

export const DOM_SANITIZER_CONTEXTS = {
  HTML: DomSanitizerContext.HTML,
  STYLE: DomSanitizerContext.STYLE,
  SCRIPT: DomSanitizerContext.SCRIPT,
  URL: DomSanitizerContext.URL,
  RESOURCE_URL: DomSanitizerContext.RESOURCE_URL,
};
